function SiteHeader({
  $window,
  sync,
  APIEndpoint,
  refreshAccountDetails,
}) {
  const logout = APIEndpoint.post('/sessions/logout')

  let menu = null
  let account = null
  let isMenuOpen = false
  $window.addEventListener('click', function(e) {
    if (isMenuOpen && !menu.contains(e.target)) {
      isMenuOpen = false
      sync()
    }
  })
  return {
    getMenuReference(el) {
      menu = el
    },
    isLoggedIn: () => account !== null,
    isMenuOpen: () => isMenuOpen,
    handleAccountRefresh(_account) {
      account = _account
      if (account === null) {
        isMenuOpen = false
      }
    },
    toggleMenu() {
      isMenuOpen = !isMenuOpen
    },
    logout: () => logout()
      .then(() => refreshAccountDetails())
      .catch(res => $window.console.error(res)),
    __proto__: SiteHeader.prototype,
  }
}

Object.assign(exports, { SiteHeader })
